import { onMounted, onUnmounted } from '@vue/composition-api'

export default ({ name, onResult }) => {
  let _resolve = null
  let _reject = null
  if (window.ReactNativeResponses) {
    onMounted(() => {
      window.ReactNativeResponses[name] = onResult
      window.ReactNativeResponses[`${name}End`] = params => {
        _resolve(params)
      }
      window.ReactNativeResponses[`${name}Fail`] = params => {
        _reject(params)
      }
    })
    onUnmounted(() => {
      window.ReactNativeResponses[name] = null
      window.ReactNativeResponses[`${name}End`] = null
      window.ReactNativeResponses[`${name}Fail`] = null
    })
  }
  return {
    callback: params => new Promise((resolve, reject) => {
      _resolve = resolve
      _reject = reject
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          name,
          params
        })
      )
    })
  }
}
